import get from 'lodash-es/get'
import * as React from 'react'

import { IItemCard } from '../interface'

import { formatItemNameForPreview } from '../../../../common/utils/item'
import CollectionButton from '../../buttons/collectionButton'
import DownloadButton from '../../buttons/downloadButton/downloadButton'
import FavoriteButton from '../../buttons/favoriteButton/favoriteButton'

import * as styles from './lockupListActionPanel.module.css'

interface IProps extends IItemCard {
  includeDownload?: boolean
}

const LockupListActionPanel = ({
  item,
  onAddToCollections,
  onAddToFavourites,
  onDownloadPreview,
  includeDownload
}: IProps) => (
  <div className={styles.root}>
    {includeDownload ? (
      <DownloadButton
        onClick={onDownloadPreview}
        iconClassName={styles.downloadButton}
        href={get(item, 'previews.icon_with_audio_preview.mp3_url')}
        download={formatItemNameForPreview(item)}
      />
    ) : null}
    <CollectionButton
      href={`/bookmarks/widget?item_id=${item.id}`}
      onClick={onAddToCollections}
      isActive={false}
      iconClassName={styles.collectionButton}
    />
    <FavoriteButton
      href={`/favorites?item_id=${item.id}`}
      onClick={onAddToFavourites}
      isActive={item.ui.isInFavourites}
      iconClassName={styles.favoriteButton}
    />
  </div>
)

export default LockupListActionPanel
